import React, { useRef } from 'react';
import './Contact.css';
import { FaFacebookF, FaInstagram, FaGithub, FaLinkedinIn, FaTiktok } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_fy1niwp', // Replace with your EmailJS service ID
      'template_akm36ni', // Replace with your EmailJS template ID
      formRef.current,
      '1adByH6e2T5bm6Msy' // Replace with your EmailJS user ID
    ).then(
      (result) => {
        console.log(result.text);
        alert('Message sent successfully!');
      },
      (error) => {
        console.error(error.text);
        alert('Failed to send message, please try again later.');
      }
    );
  };

  return (
    <div className="contact-container">
      <div className="contact-image">
        <img src="/408468451_878625600608684_5428179891134115938_n.jpg" alt="Contact" />
      </div>
      
      <div className="contact-content">
        <h1>Contact Me</h1>
        
        <form ref={formRef} onSubmit={sendEmail} className="contact-form">
          <div className="form-group">
            <input type="text" name="full_name" placeholder="Full Name" required />
          </div>

          <div className="form-group">
            <input type="email" name="email" placeholder="E-mail" required />
          </div>

          <div className="form-group">
            <textarea name="message" placeholder="Message" required></textarea>
          </div>

          <button type="submit" className="contact-button">Contact Us</button>
        </form>

        <div className="contact-info">
          <div className="info-item">
            <h3>Contact</h3>
            <p>taovietduc.work@gmail.com 📩</p>
          </div>

          <div className="info-item">
            <h3>Based in</h3>
            <p>Ho Chi Minh City, Vietnam</p>
          </div>

          <div className="social-links-contact">
            <a href="https://www.facebook.com/TAOVIETDUCOFFICIAL"><FaFacebookF size={20} /></a>
            <a href="https://www.instagram.com/taovietduc_"><FaInstagram size={20} /></a>
            <a href="https://www.tiktok.com/@taovietduc_"><FaTiktok size={20} /></a>
            <a href="https://github.com/taovietducofficial"><FaGithub size={20} /></a>
            <a href="https://www.linkedin.com/in/taovietduc19"><FaLinkedinIn size={20} /></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
